import Model, {
  AsyncBelongsTo,
  AsyncHasMany,
  attr,
  belongsTo,
  hasMany,
} from '@ember-data/model';

import type HotelModel from 'admin-panel/models/hotel';
import type PageModel from 'admin-panel/models/page';
import type ItemModel from 'admin-panel/models/item';

export default class CategoryModel extends Model {
  @belongsTo('hotel')
  declare hotel: AsyncBelongsTo<HotelModel>;

  @hasMany('page')
  declare pages: AsyncHasMany<PageModel>;

  @hasMany('item')
  declare items: AsyncHasMany<ItemModel>;

  @attr
  declare title: string;

  @attr
  declare code: string;

  @attr({ defaultValue: '' })
  declare cron: string;

  @attr
  declare enableAsap: boolean;

  @attr
  declare datetimeSelectable: boolean;

  @attr
  declare confirmationMethods: string;

  @attr
  declare signatureRequired: boolean;

  get pagesCount() {
    return this.pageIds.length;
  }

  get pageIds() {
    return this.hasMany('pages' as Exclude<keyof this, keyof Model>)
      .ids()
      .filter((id): id is string => id !== null && id !== undefined);
  }

  get itemsCount() {
    return this.hasMany('items' as Exclude<keyof this, keyof Model>).ids()
      .length;
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    category: CategoryModel;
  }
}
